module.exports = __webpack_public_path__ + "img/p-buy-not.a2057dac.png";